import React, { useState } from 'react'
import { Loader } from 'react-bootstrap-typeahead'
import { useWorkshopAdminLoginMutation } from '../../../Services/vehicle/Vehicle';
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from '@mui/x-data-grid';
import WorkshopRequestOnboard from '../../../pages/vehicle/workshop/WorkshopRequestOnboard';
import { GARAGE_ROLE, GARAGE_TOKEN } from '../../../constants';
import { toast } from 'react-toastify';
import {
  getTenantSubdomain,
  isAutoServicesTenant,
  TENANT_BRANDING_LOGOS,
} from '../../../utils/tenantBranding';

const AdminLogin = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false);
  const [openWorkshopModal, setOpenWorkshopModal] = useState(false)
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };



  const [workshopLoginTrigger] = useWorkshopAdminLoginMutation()

  const validateForm = () => {
    let isValid = true;

    // Email Validation
    if (!email.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setEmailError("Enter a valid email address");
      isValid = false;
    } else {
      setEmailError("");
    }

    // Password Validation
    if (!password.trim()) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };


  const loginHandler = async () => {
    if (!validateForm()) return;
    const loginPayload = {
      email: email,
      password: password
    }
    try {
      const response = await workshopLoginTrigger(loginPayload).unwrap()

      if (response?.data) {
      
        if (response?.data?.role === "garage_tenant_admin") {
          localStorage.setItem(GARAGE_ROLE, response?.data?.role)
          localStorage.setItem(GARAGE_TOKEN, response?.data?.token)
          window.location.replace('/vehicle/workshop-listed');
        } else if (response?.data?.role === "garage_admin") {
          toast.error("Invalid credentials")
        
        }

      }
      else if (response?.error) {
        console.log(response?.error, "eooeoeoee")

      }
    } catch (error) {
      toast.error("An error occured")

    }

  }

  // Why it is unable to save anything inside the data???
  const onboardWorkshopHandler = () => {
    setOpenWorkshopModal(true)
  }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };


  const closeModal = () => {
    setOpenWorkshopModal(false)

  }

  //   useEffect(() => {
  //   const token = localStorage.getItem(GARAGE_TOKEN);
  //   if (token) {
  //     // localStorage.removeItem(GARAGE_TOKEN);
  //     // localStorage.removeItem(GARAGE_ROLE); 
  //     localStorage.clear()
  //     window.location.replace('/auth/admin-login')
  //   }
  // }, []);

  // useEffect(() => {
  //   localStorage.clear()
  //     window.location.replace('/auth/admin-login')

  // }, [])
  const fetchingTenant = getTenantSubdomain();
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);

  return (
    <div className="login-container" style={{ paddingTop: "0px" }}>

      <div className="logo" style={{ marginBottom: "1rem" }}>
        {autoServicesBranding ? (
          <img
            src={TENANT_BRANDING_LOGOS.autoServices}
            alt="Auto Services logo"
            style={{ width: "300px", height: "100px" }}
          />
        ) : (
          <img
            src={TENANT_BRANDING_LOGOS.eurorepar}
            alt="EUROREPAR Logo"
            style={{ width: "200px" }}
          />
        )}
        {/* <h1>dcsdcs</h1> */}
        {/* <h2>EUROREPAR <span>CAR SERVICE</span></h2> */}
      </div>

      <p className="welcome-text" style={{ fontSize: "30px", margin: "5px", marginTop: "0" }}>
        {autoServicesBranding ? "Welcome to Auto Services!" : "Welcome!"}
      </p>

      <div className="login-box">
        {/* <h4 className="login-heading" >Log In</h4> */}
        {/* <p className="login-subheading">Log In with Email or Mobile Number</p> */}

        <div className="input-group" style={{ marginBottom: emailError ? "0px" : "1.5rem" }}>
          <label>Username</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" id="email" placeholder="Enter email address" style={{ borderRadius: "50px" }} />
          {emailError && <p style={{ color: "red", marginTop: "4px", marginBottom: "10px", marginLeft: "10px" }}>{emailError}</p>}

        </div>

        <div className="input-group" style={{ position: "relative", marginBottom: passwordError ? "0px" : "1.5rem" }}>
          <label>Password</label>
          <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} id="password" placeholder="Enter your password" style={{ borderRadius: "50px" }} />

          <div className="input-group-append">
            <span
              // className="form-control form-control-lg form-control-solid"
              id="togglePassword"
              onClick={togglePasswordVisibility}
              style={{
                cursor: "pointer",
                borderRadius: "0px 5px 5px 0px",
                position: "absolute",
                left: "90%",
                top: "50%"
              }}
            >
              {showPassword ? (
                <i className="bi bi-eye-slash text-dark"></i>
              ) : (
                <i className="bi bi-eye text-dark"></i>
              )}
            </span>
          </div>

        </div>
        {passwordError && (
          <p style={{ color: "red", marginTop: "4px", marginBottom: "10px", marginLeft: "10px" }}>{passwordError}</p>
        )}
        {/* {isEmailSelected ? (
        ) : (
          <div className="input-group">
            <label>Mobile number</label>
            <input  type="number" id="mobile" placeholder="Enter mobile number" style={{borderRadius: "50px"}}/>
          </div>
        )} */}

        <button onClick={loginHandler} disabled={loading} className={loading ? "loading-state" : "send-otp"}>{loading ? <><Loader /></> : "Continue"}</button>
        <button className='send-otp' style={{ width: "100%", marginTop: "20px" }} onClick={onboardWorkshopHandler}>

          <span>Onboard Workshop</span>
        </button>
      </div>

      <Modal
        open={openWorkshopModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >

          </Typography>

          <Box>

            <WorkshopRequestOnboard closeModal={closeModal} />

          </Box>
        </Box>
      </Modal>

    </div>

  )
}

export default AdminLogin